import React, { FC } from 'react'
import {
  Filter,
  List,
  Datagrid,
  TextField,
  TextInput,
  ListProps,
} from 'react-admin'

const TagsFilter = (props: any) => {
  return (
    <Filter {...props}>
      <TextInput label="Search" source="q" alwaysOn />
    </Filter>
  )
}

export const ListTags: FC<ListProps> = (props: any) => {
  const { staticContext, ...rest } = props
  return (
    <List
      // filters={<TagsFilter />}
      {...rest}
      data-testid="list"
    >
      <Datagrid rowClick={'edit'}>
        <TextField label="#" source="id" />
        <TextField label="Título" source="title" />
        <TextField label="Slug" source="slug" />
        <TextField label="Descrição" source="description" />
      </Datagrid>
    </List>
  )
}
